import React, { useState } from 'react';
import { useToasts } from 'Context';
import { ConfirmDialog } from 'v3/Components/Shared/ConfirmDialog';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import { buildEndpoint, useApiWorker } from 'Utilities';
import './ReviewerProfile.DiscardDialog.scss';

type ReviewerProfileDiscardDialogProps = {
  reviewerId: string;
  dialogVisible: boolean;
  toggleDialog: () => void;
  onSuccess: () => void;
};

const ReviewerProfileDiscardDialog: React.FC<ReviewerProfileDiscardDialogProps> = ({
  reviewerId,
  dialogVisible,
  toggleDialog,
  onSuccess,
}) => {
  const toast = useToasts();
  const API = useApiWorker('3.0');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      const result: any = await API.delete(buildEndpoint(ENDPOINTS.reviewers.base, reviewerId));
      if (result?.status >= 200 && result?.status < 300) {
        toast.success('Reviewer has been discarded');
        onSuccess();
        toggleDialog();
      }
    } catch (err: any) {
      const status = err?.response?.status;
      const message = err?.response?.data?.message;
      if (status === 400) {
        toast.error(message ?? 'This reviewer cannot be discarded.');
      } else if (status === 403) {
        toast.error(message ?? 'You do not have permission to perform this action.');
      } else {
        toast.error('Failed to discard reviewer. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ConfirmDialog
      dialogVisible={dialogVisible}
      toggleDialog={toggleDialog}
      className="discard-reviewer-dialog"
      title="Discard Reviewer"
      primaryButtonText={isSubmitting ? 'Discarding...' : 'Discard'}
      primaryButtonEnabled={!isSubmitting}
      isPrimaryDanger
      OnPrimaryButtonClick={handleConfirm}
      secondaryButtonText="Cancel"
      OnSecondaryButtonClick={toggleDialog}
    >
      <p className="discard-reviewer-dialog__description">
        Are you sure you want to discard this reviewer profile? This will remove the reviewer and their information permanently from the system. 
      </p>
    </ConfirmDialog>
  );
};

export default ReviewerProfileDiscardDialog;
